import $ from "jquery";

window.jQuery = window.$ = $;

import { ninegrid } from "./utils/ninegrid.js";



import "./utils/ngContainer4.js";


import "./components/ngContainer.js";
import "./components/ngContainer2.js";

//import "./etc/___ninegrid.js";
//import "./etc/___ninegrid.js";
//import "./etc/__ngUtils.js";
import "./etc/_ngCell.js";

import "./etc/ngButton.js";

import "./etc/ngCellCopyPaste.js";
import "./etc/ngCellManager.js";
import "./etc/ngCellSelection.js";
import "./etc/ngCellTouchEvent.js";
import "./etc/ngChart.js";

import "./etc/ngCheckBox.js";

import "./etc/ngColExpand.js";



//import "./etc/ngColIndicator.js";
import "./etc/ngColMover.js";
import "./etc/ngColResizer.js";
import "./etc/ngColumns.js";
import "./etc/ngCombo.js";
import "./etc/ngContextMenu.js";

import "./etc/ngCustomEvent.js";
import "./etc/ngData.js";
import "./etc/ngDataManager.js";
import "./etc/ngExpandIcon.js";
import "./etc/ngExport.js";
import "./etc/ngFields.js";
import "./etc/ngFoot.js";
import "./etc/ngHead.js";
import "./etc/ngIcon.js";
import "./etc/ngImage.js";
import "./etc/ngImport.js";
import "./etc/ngInfo.js";
import "./etc/ngInputColor.js";
import "./etc/ngInputDate.js";
import "./etc/ngInputText.js";


import "./etc/ngMatrixManager.js";
import "./etc/ngMaximize.js";
import "./etc/ngMenu.js";
import "./etc/ngPaging.js";
import "./etc/ngProgress.js";
import "./etc/ngRadio.js";
import "./etc/ngRenderer.js";
import "./etc/ngRowDetail.js";
import "./etc/ngRowDrag.js";
import "./etc/ngRowExpand.js";
import "./etc/ngRowIndicator.js";
import "./etc/ngRowPin.js";
import "./etc/ngRowState.js";
import "./etc/ngScrollBar.js";
import "./etc/ngSorting.js";
import "./etc/ngTableManager.js";
import "./etc/ngTableWrapper.js";
import "./etc/ngTextArea.js";
import "./etc/ngTree.js";
import "./etc/ngView.js";
import { NineGridContainer } from "./etc/ninegridContainer.js";
import "./etc/nxConfirm.js";
import "./etc/nxDialog.js";
import "./etc/nxI18nExt.js";
import "./etc/nxSidebar.js";
import "./etc/nxSideMenu.js";
import "./etc/nxSpan.js";
import "./etc/nxTest.js";
import "./etc/nxTopMenu.js";
//import "./etc/object-observe.js";

import "./utils/ngFiltering.js";
import "./utils/ngPrototype.js";


//import "./nx/nxDiv.js";
import "./nx/nxCollapse.js";
import "./nx/nxTab.js";
import "./nx/nxSplitter.js";
import "./nx/nxForm.js";
import "./nx/nxTitle.js";
import "./nx/nxTitle2.js";
import "./nx/nxLayout.js";
import "./nx/nxLayout2.js";
import "./nx/nxPanel.js";
//import "./nx/nxPanel2.js";
import "./nx/nxButtons.js";
import "./nx/nxModal.js";
//import "./nx/nxEditor.js";

//import "./ai/aiSettings.js";
//import "./ai/aiMessage.js";
//import "./ai/aiContainer.js";
//import "./ide-assi/ideAssi.js";

export { NineGridContainer }; // Named Export

// ✅ Custom Elements 등록 함수 정의
export function defineCustomElements() {
    if (!customElements.get("nine-grid")) {
        customElements.define("nine-grid", NineGridContainer);
    }
}

export default ninegrid;
